import { render, staticRenderFns } from "./orderServicerAll.vue?vue&type=template&id=68a0ce63&"
import script from "./orderServicerAll.vue?vue&type=script&lang=ts&"
export * from "./orderServicerAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports